import React from "react";
import Cookies from 'js-cookie';

const Cancelledpayments = ({ columns, rows, nodatatext, eftcontent }) => {

    return (
        <>
            <table tabIndex={0} className="table table-striped" style={{ marginLeft: '' }}>
                <thead className="sticky-top">
                    <tr>
                        {
                            columns && columns?.map((item) => <th scope="col">{item}</th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    {rows?.length == 0 ? (
                        <td colSpan={4} className="fw-semibold"><div className="d-flex px-2">
                            <div className="col-12 mb-2">
                                <h6 className="paymenthistorymodal">{nodatatext}</h6>
                            </div>
                        </div> </td>
                    ) : (
                        rows && rows?.map((item, index) => <tr key={index} className="border-bottom">
                            <td>{item.name}</td>
                            <td>{(item.type === 'EFT via Web' && Cookies.get('owningCarrier') === 'Q5') ? eftcontent : item.type}</td>
                            <td>{item.event_date}</td>
                            <td>{item.amount}</td>
                        </tr>)
                    )}
                </tbody>
            </table>
        </>
    )
}

export default Cancelledpayments;